exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subheading {\n  font-weight: 700;\n  font-size: 14px !important;\n}\n.headline {\n  font-size: 20px !important;\n}\n", ""]);

// exports
